import { render, staticRenderFns } from "./OverFlowCount.vue?vue&type=template&id=4d7c1d10&scoped=true&"
import script from "./OverFlowCount.vue?vue&type=script&lang=ts&"
export * from "./OverFlowCount.vue?vue&type=script&lang=ts&"
import style0 from "./OverFlowCount.vue?vue&type=style&index=0&id=4d7c1d10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7c1d10",
  null
  
)

export default component.exports